import { render } from "./NewCommentForm.vue?vue&type=template&id=3c6e6c60&scoped=true"
import script from "./NewCommentForm.vue?vue&type=script&lang=js"
export * from "./NewCommentForm.vue?vue&type=script&lang=js"

import "./NewCommentForm.vue?vue&type=style&index=0&id=3c6e6c60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6e6c60"]])

export default __exports__